import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Sesión con la API CNXT/Mimetika (https://cnxt-api.indo.es).
 *
 * La API devuelve un `Session-Token` en la cabecera de respuesta de las
 * llamadas iniciales (GetPacientes / Mimetika_Measurements) y hay que
 * reenviarlo en TODAS las llamadas posteriores. Se persiste en localStorage
 * para que la sesión sobreviva a cerrar el navegador.
 *
 * `connected` refleja la última llamada inicial: false si devolvió la URL de
 * login, true si devolvió datos.
 */
export const useCnxtSessionStore = defineStore(
  "cnxtSession",
  () => {
    const cnxtMimetikaSessionToken = ref(null);
    const connected = ref(false);

    function setSessionToken(token) {
      cnxtMimetikaSessionToken.value = token || null;
    }

    function setConnected(value) {
      connected.value = !!value;
    }

    /** Olvida la sesión: la próxima llamada a la API devolverá la URL de login. */
    function disconnect() {
      cnxtMimetikaSessionToken.value = null;
      connected.value = false;
    }

    return { cnxtMimetikaSessionToken, connected, setSessionToken, setConnected, disconnect };
  },
  {
    persist: {
      key: "cnxtMimetikaSessionToken",
      storage: localStorage,
    },
  },
);
